import { useMemo } from 'react';

import { createFilterOptions } from '@mui/material';

import { AutocompleteElement } from 'commonComponents/AutocompleteElement';

import { useLicenseSerialNumbers } from 'api/licenses';

export function SerialNumber({
    currentProduct,
    customerId,
    onSerialNumberSelected,
    label = 'Serial Number',
    name = 'serial_number',
    disabled = false,
}) {
    const { data: serialNumbers, isLoading } = useLicenseSerialNumbers(currentProduct?.id, customerId);
    const options = useMemo(() => serialNumbers?.map(value => value.serial_number) ?? [], [serialNumbers]);
    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        limit: 100,
    });

    const isOptionEqualToValue = (option, value) => option?.toLowerCase() === value?.toLowerCase();

    const handleChanged = value => {
        if (onSerialNumberSelected && serialNumbers) {
            const matchingSn = serialNumbers.find(i => isOptionEqualToValue(i.serial_number, value));
            if (matchingSn) {
                onSerialNumberSelected(matchingSn);
            }
        }
    };

    return (
        <AutocompleteElement
            label={label}
            name={name}
            options={options}
            autoSelect
            freeSolo
            filterOptions={filterOptions}
            isOptionEqualToValue={isOptionEqualToValue}
            onChangeCallback={(event, value, _reason, _details) => handleChanged(value)}
            loading={isLoading}
            disabled={disabled}
        />
    );
}
